<template>
  <div
    class="uni-calendar-item__weeks-box"
    :class="{
      'uni-calendar-item--disable': weeks.disable,
      'uni-calendar-item--before-checked-x': weeks.beforeMultiple,
      'uni-calendar-item--multiple': weeks.multiple,
      'uni-calendar-item--after-checked-x': weeks.afterMultiple
    }"
    @click="choiceDate(weeks)"
    @mouseenter="handleMousemove(weeks)"
  >
    <div
      class="uni-calendar-item__weeks-box-item"
      :class="{
        'uni-calendar-item--checked':
          calendar.fullDate === weeks.fullDate && (calendar.userChecked || !checkHover),
        'uni-calendar-item--checked-range-text': checkHover,
        'uni-calendar-item--before-checked': weeks.beforeMultiple,
        'uni-calendar-item--multiple': weeks.multiple,
        'uni-calendar-item--after-checked': weeks.afterMultiple,
        'uni-calendar-item--disable': weeks.disable
      }"
    >
      <span v-if="selected && weeks.extraInfo" class="uni-calendar-item__weeks-box-circle"></span>
      <span
        class="uni-calendar-item__weeks-box-text uni-calendar-item__weeks-box-text-disable uni-calendar-item--checked-text"
        >{{ weeks.date }}</span
      >
    </div>
    <div :class="{ 'uni-calendar-item--today': weeks.isToday }"></div>
  </div>
</template>

<script>
export default {
  props: {
    weeks: {
      type: Object,
      default() {
        return {}
      }
    },
    calendar: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selected: {
      type: Array,
      default: () => {
        return []
      }
    },
    checkHover: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    choiceDate(weeks) {
      this.$emit('change', weeks)
    },
    handleMousemove(weeks) {
      this.$emit('handleMouse', weeks)
    }
  }
}
</script>

<style lang="scss">
$uni-primary: #007aff !default;

.uni-calendar-item__weeks-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0.021333rem 0;
  position: relative;
}

.uni-calendar-item__weeks-box-text {
  font-size: 0.298667rem;
  // font-family: Lato-Bold, Lato;
  font-weight: bold;
  color: darken($color: $uni-primary, $amount: 40%);
}

.uni-calendar-item__weeks-box-item {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 0.853333rem;
  height: 0.853333rem;
  cursor: pointer;
}

.uni-calendar-item__weeks-box-circle {
  position: absolute;
  top: 0.106667rem;
  right: 0.106667rem;
  width: 0.170667rem;
  height: 0.170667rem;
  border-radius: 0.170667rem;
  background-color: #dd524d;
}

.uni-calendar-item__weeks-box .uni-calendar-item--disable {
  cursor: default;
}

.uni-calendar-item--disable .uni-calendar-item__weeks-box-text-disable {
  color: #d1d1d1;
}

.uni-calendar-item--today {
  position: absolute;
  top: 0.213333rem;
  right: 17%;
  background-color: #dd524d;
  width: 0.128rem;
  height: 0.128rem;
  border-radius: 50%;
}

.uni-calendar-item--extra {
  color: #dd524d;
  opacity: 0.8;
}

.uni-calendar-item__weeks-box .uni-calendar-item--checked {
  background-color: $uni-primary;
  border-radius: 50%;
  box-sizing: border-box;
  border: 0.064rem solid #fff;
}

.uni-calendar-item--checked .uni-calendar-item--checked-text {
  color: #fff;
}

.uni-calendar-item--multiple .uni-calendar-item--checked-range-text {
  color: #333;
}

.uni-calendar-item--multiple {
  background-color: #f6f7fc;
  // color: #fff;
}

.uni-calendar-item--multiple .uni-calendar-item--before-checked,
.uni-calendar-item--multiple .uni-calendar-item--after-checked {
  background-color: $uni-primary;
  border-radius: 50%;
  box-sizing: border-box;
  border: 0.064rem solid #f6f7fc;
}

.uni-calendar-item--before-checked .uni-calendar-item--checked-text,
.uni-calendar-item--after-checked .uni-calendar-item--checked-text {
  color: #fff;
}

.uni-calendar-item--before-checked-x {
  border-top-left-radius: 1.066667rem;
  border-bottom-left-radius: 1.066667rem;
  box-sizing: border-box;
  background-color: #f6f7fc;
}

.uni-calendar-item--after-checked-x {
  border-top-right-radius: 1.066667rem;
  border-bottom-right-radius: 1.066667rem;
  background-color: #f6f7fc;
}
</style>
